export async function RetrievCustomFiles(token, config_id) {
  const url =
    "https://kesxkrclz0.execute-api.us-east-1.amazonaws.com/Testing/configurations/customFiles?config_id=" +
    config_id;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching CustomFiles: ${response.status} ${response.statusText}`
      );
    }

    const data = await response.json();
    // console.log("CustomFiles retrieved successfully:", data);
    return data;
  } catch (error) {
    console.error("Failed to fetch CustomFiles:", error);
    throw error;
  }
}
